import React, { useState, useEffect } from "react";

const TotalsSummary = ({
  totals = {},
  orderData = {},
  isProductOnlyOrder = false,
}) => {
  const [taxAmount, setTaxAmount] = useState(0);
  const [amountWithoutTax, setAmountWithoutTax] = useState(0);

  useEffect(() => {
    setTaxAmount(parseFloat(totals.discountedGST || 0).toFixed(2));
    setAmountWithoutTax(parseFloat(totals.netAmount || totals.subtotal || 0));
  }, [totals]);

  const paidAmount = parseFloat(orderData?.total_paid_amount || 0);
  const adjustedAmount = parseFloat(
    orderData?.adjustment_amount || orderData?.waived_amount || 0
  );
  const discountAmount = parseFloat(orderData?.discount_amount || orderData?.total_discount || 0);

  const orderAmount = parseFloat(orderData?.grand_total || totals?.total || orderData?.amount_after_adjustment || 0);

  const totalSaved = orderData.final_discount || orderData?.total_discount || orderData?.discount_amount || 0;

  const totalDiscountAmount = parseFloat(totals?.total_discount || 0);
  const hasTax = Number(taxAmount) > 0;
  const hasDiscount = Number(totalDiscountAmount) > 0;

  return (
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-3 space-y-2">
      {hasDiscount && (
        <>
          <div className="flex justify-between text-sm">
            <span>Sub Total</span>
            <span>₹ {totals.subtotal.toFixed(2)}</span>
          </div>

          <div className="flex justify-between text-sm">
            <span>Discount</span>
            <span>₹ {(Number(totalDiscountAmount) || 0).toFixed(2)}</span>
          </div>
        </>
      )}
      {hasTax && (
        <>
          <div className="flex justify-between text-sm">
            <span>Net Amount</span>
            <span>₹ {amountWithoutTax.toFixed(2)}</span>
          </div>

          <div className="flex justify-between text-sm">
            <span>Taxes</span>
            <span>₹ {(Number(taxAmount) || 0).toFixed(2)}</span>
          </div>
        </>
      )}

      <div className={`flex justify-between text-lg font-bold ${hasTax ? "border-t border-gray-200 pt-2" : ""}`}>
        <span>Order Amount</span>
        <span>₹ {Math.round(orderAmount)}</span>
      </div>

      <div className="flex justify-between text-sm">
        <span>Paid</span>
        <span>₹ {paidAmount.toFixed(2)}</span>
      </div>

      {/* {adjustedAmount > 0 && (
        <div className="flex justify-between text-sm">
          <span>Adjustment</span>
          <span>₹ {adjustedAmount.toFixed(2)}</span>
        </div>
      )} */}

      {totalSaved > 0 && (
        <div className="flex items-center justify-center gap-1.5 bg-green-50 border border-green-200 rounded-lg px-3 py-2 mt-1">
          <span className="text-base">🎉</span>
          <span className="text-sm font-medium text-green-700">
            You have saved ₹ {totalSaved.toFixed(2)} on this order
          </span>
        </div>
      )}
    </div>
  );
};

export default TotalsSummary;